// extracted by mini-css-extract-plugin
export default {"auditLogs":"styles_auditLogs__5abXA","dateFilter":"styles_dateFilter__Rm8gL"};